
import React from 'react';

import { translate } from '../../../base/i18n';
import { connect } from '../../../base/redux';
import { getBrandingColorPalette } from '../../../base/styles';
import { styleDeeplinking } from '../../../deep-linking/components/styleWeb';
import { Footer } from '../../../welcome/components/Footer';
import { Header } from '../../../welcome/components/Header';

import AbstractUserMediaPermissionsOverlay, { abstractMapStateToProps }
    from './AbstractUserMediaPermissionsOverlay';
import OverlayFrame from './OverlayFrame';


const COLOR_WHITE = '#fff';

const COLOR_FFF = '#FFF';
const COLOR_UNSET = '';


const _inlineStyles = {
    _s0: { maxWidth: '1120px!important',
        marginTop: '5%' },
    _s1: { color: COLOR_WHITE }
};

declare var interfaceConfig: Object;

/**
 * Implements a React Component for overlay with guidance how to proceed with
 * gUM prompt.
 */
class UserMediaPermissionsOverlay extends AbstractUserMediaPermissionsOverlay {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { t } = this.props;
        const _dsMainBox = {
            width: '80%',
            maxWidth: '800px',
            borderRadius: '10px',
            margin: 'auto',
            backgroundColor: getBrandingColorPalette(interfaceConfig)?.primary,
            color: COLOR_FFF,
            padding: '20px'
        };
        const _dsIcon = {
            fontSize: '64px',
            color: getBrandingColorPalette(interfaceConfig)?.secondary
        };
        const _dsH4 = {
            marginTop: '10px',
            color: interfaceConfig.applyMeetingSettings ? getBrandingColorPalette(interfaceConfig)?.accent1 : COLOR_UNSET
        };
        const _dsH6 = {
            color: interfaceConfig.applyMeetingSettings ? getBrandingColorPalette(interfaceConfig)?.accent1 : COLOR_WHITE
        };


        return (
            <OverlayFrame>
                <Header
                    prejoin = { false } />
                <div
                    className = 'container'
                    style = { _inlineStyles._s0 }>
                    <div className = 'row'>
                        <div className = 'col-m-12 col-sm-12'>
                            <br /><br /><br />
                            <div
                                className = 'text-center'
                                style = { _dsMainBox }>

                                <i
                                    className = 'bx bx-video'
                                    style = { _dsIcon } /><i
                                    className = 'bx bxs-microphone'
                                    style = { _dsIcon } /><br />

                                <h4
                                    style = { _dsH4 }>
                                    {t('audioDevices.permissions1')}</h4>

                                <hr style = { _inlineStyles._s1 } /><h6 style = { _dsH6 }>
                                    {t('audioDevices.permissions2')}</h6>


                            </div>
                            <br /><br />


                        </div>


                    </div>
                </div>
                <Footer
                    prejoin = { false }
                    style = { styleDeeplinking(interfaceConfig).width100 } />
            </OverlayFrame>
        );
    }

    /**
     * Renders the policy logo.
     *
     * @private
     * @returns {ReactElement|null}
     */
    _renderPolicyLogo() {
        const policyLogoSrc = interfaceConfig.POLICY_LOGO;

        if (policyLogoSrc) {
            return (
                <div className = 'policy__logo'>
                    <img src = { policyLogoSrc } />
                </div>
            );
        }

        return null;
    }
}


export default translate(
    connect(abstractMapStateToProps)(UserMediaPermissionsOverlay));
